export enum ErrorCode {
  Undefined = -1,
  InvalidQuote = 1,
  TenantIdIsRequired = 2,
  ShortCodeIsRequired = 3,
  QuoteIsAccepted = 4,
  QuoteIsNotSigned = 5,
  AddressIsRequired = 6,
}

export const QuoteErrors = [ErrorCode.InvalidQuote, ErrorCode.QuoteIsAccepted, ErrorCode.QuoteIsNotSigned];
